export default "__VITE_ASSET__k695fz8R__"